import React from 'react';
import PermWrapper from '../PermWrapper';
import BuriedWrapper from '.';

/**
 * 埋点跟权限合并，只支持一个节点
 * @param {Object} props
 * @param {*} props.children
 * @param {string} props.eventId
 * @param {string=} props.eventType
 * @param {string=} props.pageUrl
 * @param {string} props.resource 资源
 * @param {string=} props.triggerEvent 默认触发事件
 *  */
export default function BuriedPermWrapper({
  resource,
  children,
  eventId,
  eventType,
  pageUrl,
  triggerEvent = 'onClick',
  ...props
}) {
  return (
    <PermWrapper resource={resource}>
      <BuriedWrapper
        eventId={eventId}
        eventType={eventType}
        pageUrl={pageUrl}
        triggerEvent={triggerEvent}
        {...props}
      >
        {React.cloneElement(React.Children.only(children), props)}
      </BuriedWrapper>
    </PermWrapper>
  );
}
